<template lang="pug">
  v-card.orders.body.inner-scroll
    portal(to='toolbar')
      v-toolbar-title Payments / Orders
    .d-flex.px-3.py-3.align-center
      orders-filters(
        @filterChanged="onFiltersChanged"
      )
    list(
      :loading="listLoading"
      :list="list"
      :pagination="pagination"
      :headers="headers"
      :sort-model="sortModel"
      hide-actions
      sortable
      hide-select
      v-slot="{item}"
      @loadMoreClick="loadListMore"
      @sortChanged="loadList"
    )
      td.pl-4 {{ item.plan }}
      td.pl-4 {{ item.paid_at }}
      td.pl-4 {{ item.expires_in }}
      td.pl-4.w-100.text-center
        status-button(:status="item.is_active")
      td.pl-4 {{ item.deactivated_at }}
</template>

<script>
import ErrorMixin from "@/mixins/errors.mixin"
import {PaymentsService} from "../core/payments-service";
import {OrdersSortingModel} from "../core/models/OrdersSortingModel";
import {FILTERS_ARGS} from "@/app/exercise/modules/payments/core/models/OrdersConst";
import * as moment from 'moment'

export default {
  components: {
    list: () => import('@/app/exercise/components/ItemsList'),
    statusButton: () => import('@/app/exercise/components/StatusButton'),
    ordersFilters: () => import('@/app/exercise/modules/payments/components/OrdersFilters')
  },

  data() {
    return {
      svc: null,
      list: [],
      listLoading: false,
      pagination: null,
      headers: [
        { text: 'Plan', align: 'left', class: 'pl-4', value: 'plan__name'},
        { text: 'Paid at', align: 'left', class: 'pl-4', value: 'paid_at'},
        { text: 'Expires in', align: 'left', class: 'pl-4', value: 'expires_in'},
        { text: 'Is active', align: 'center', class: 'pl-4 w-100', value: 'is_active'},
        { text: 'Deactivated at', align: 'left', class: 'pl-4', value: 'deactivated_at'}
      ],
      sortModel: null
    }
  },

  mixins: [ErrorMixin],

  created() {
    this.init()
  },

  async mounted() {
    this.pagination = {
      page: 1
    };

    this.loadList();
  },

  methods: {
    init() {
      this.svc = new PaymentsService(this.$auth);
      this.sortModel = new OrdersSortingModel(this.$route.query);
    },

    async loadList() {
      try {
        this.listLoading = true;
        const transformedParams = this.transformDateParams({...this.$route.query});
        let { results, pagination } = await this.svc.loadOrders({
          ...transformedParams,
          page: 1,
        });
        this.pagination = pagination;
        this.list = results || [];
        this.listLoading = false;
      } catch (error) {
        this.listLoading = false;
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE});
      }
    },

    async loadListMore(page) {
      try {
        this.listLoading = true;
        const transformedParams = this.transformDateParams({...this.$route.query});
        let { results } = await this.svc.loadOrders({
          ...transformedParams,
          page
        });
        this.list.push(...results);
        this.listLoading = false;
      } catch (error) {
        this.listLoading = false;
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE});
      }
    },

    transformDateParams(query) {
      const template = {
        [FILTERS_ARGS.PAID_AT_DATE]: [FILTERS_ARGS.PAID_AT_FROM, FILTERS_ARGS.PAID_AT_TO],
        [FILTERS_ARGS.EXPIRES_IN_DATE]: [FILTERS_ARGS.EXPIRES_IN_FROM, FILTERS_ARGS.EXPIRES_IN_TO],
        [FILTERS_ARGS.DEACTIVATED_AT_DATE]: [FILTERS_ARGS.DEACTIVATED_AT_FROM, FILTERS_ARGS.DEACTIVATED_AT_TO],
      }

      const dateQueriesList = [
        FILTERS_ARGS.PAID_AT_FROM,
        FILTERS_ARGS.PAID_AT_TO,
        FILTERS_ARGS.EXPIRES_IN_FROM,
        FILTERS_ARGS.EXPIRES_IN_TO,
        FILTERS_ARGS.DEACTIVATED_AT_FROM,
        FILTERS_ARGS.DEACTIVATED_AT_TO
      ]

      const params = {};
      Object.keys(query).forEach( queryKey => {
        if(dateQueriesList.includes(queryKey)) {
          Object.keys(template).forEach( dateKey => {
            if( template[dateKey].includes(queryKey) ) {
              if(query[template[dateKey][0]] && query[template[dateKey][0]] === query[template[dateKey][1]]) {
                params[dateKey] = query[template[dateKey][0]];
              } else if (query[template[dateKey][0]] && query[template[dateKey][1]]) {
                params[queryKey] = query[queryKey];
                if(queryKey.endsWith('__lte')) {
                  params[queryKey] = moment(query[queryKey]).add(1, 'day').format('YYYY-MM-DD');
                }
              } else {
                params[queryKey] = query[queryKey];
              }
            }
          } )
        } else {
          params[queryKey] = query[queryKey];
        }

      } );
      return params;
    },
    
    onFiltersChanged() {
      this.sortModel = new OrdersSortingModel({...this.$route.query});
      this.loadList();
    }
  }
}
</script>

<style lang="scss" scoped>

  .orders.v-card {
    &.body {
      height: 100vh;
      max-height: calc(100vh - 140px);
      overflow: auto;
      &.inner-scroll {
        overflow: auto;
        display: flex;
        flex-direction: column;
      }
    }
  }

  .w-100 {
    width: 100px;
  }
  .w-300 {
    width: 300px;
  }
  .w-50 {
    width: 50px;
  }
</style>

